import { generatePath } from 'react-router'

/**
 * Read blob data as json
 *
 * @param {Blob} data
 * @return {String}
 */
export const readBlobAsJson = (data) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      try {
        // Resolve
        resolve(JSON.parse(reader.result))
      } catch (error) {
        reject(error)
      }
    }

    reader.onerror = (error) => {
      reject(error)
    }

    reader.readAsText(data)
  })
}

/**
 * Resolve error message from response
 *
 * @param {Object} response
 */
export const resolveErrorMessage = async (
  error,
  message = 'Something went wrong!'
) => {
  if (error) {
    // Axios response
    if (error.response) {
      const { data } = error.response
      // Blob error
      if (data instanceof Blob && data.type === 'application/json') {
        const json = await readBlobAsJson(data)

        if (json.message) {
          return json.message
        }
      }

      // Api return with a message
      if (error.response.data && error.response.data.message) {
        return error.response.data.message
      }

      // Message from status text
      if (error.response.statusText) {
        return error.response.statusText
      }
    }

    // Error from throw
    if (error instanceof Error) {
      return error.message
    }
  }

  return message
}

/**
 * Resolve error message from response
 *
 * @param {String} path
 * @param {Object} params
 * @param {Object} query
 * @return {String}
 */
export const resolveRouteUrl = ({ path, params = {}, query = {} }) => {
  try {
    const url = generatePath(path, params)

    const searchParams = new URLSearchParams('')

    Object.keys(query).map((key) => {
      searchParams.append(key, query[key])
    })

    if (searchParams.toString()) {
      return url + '?' + searchParams.toString()
    }
    return url
  } catch (error) {
    return path
  }
}

/**
 * Substring beetween two string
 *
 * @param {String} str
 * @param {String} start
 * @param {String} end
 * @return {String}
 */
export const substringBetween = (str, start, end) => {
  return str
    ? str.substring(str.lastIndexOf(start) + 1, str.lastIndexOf(end))
    : null
}
